import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PdfViewerAdapterComponent } from './pdf-viewer-adapter.component';
import { PdfViewerAdapterService } from '@shared/pdf-viewer-adapter/services/pdf-viewer-adapter.service';
import { FormsModule } from '@angular/forms';
import { MojoInputModule } from '@shared/mojo-input/mojo-input.module';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared';

@NgModule({
  declarations: [PdfViewerAdapterComponent],
  imports: [CommonModule, MojoInputModule, SharedModule],
  exports: [PdfViewerAdapterComponent],
  providers: [PdfViewerAdapterService],
})
export class PdfViewerAdapterModule {}
